import { GameContext } from "../gameContext";

export function expectGameContext(): GameContext {
    const ctx = window.gameContext;
    if (!ctx) {
        throw new Error("Expected GameContext on window");
    }
    return ctx;
}
